import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { API, Input, Help } from '@enkla-gui'

export default function Forgot() {
	const { register, handleSubmit } = useForm()
	const [error, setError] = useState(null)
	const [sending, setSending] = useState(false)
	const [success, setSuccess] = useState(false)

	var onSubmit = data => {
		setSending(true)
		setError(null)
		API.post('api/auth/forgot', data)
			.then(res => {
				setSuccess('Ett mail har skickats med återställningsinstruktioner')
				setSending(false)
			})
			.catch(([error, res]) => {
				setError({
					message: res.message,
					data: res.data
				})
				setSending(false)
			})
	}
	return (
		<div className='full-height login-page'>
			<div className='login-card'>
				<div className='login-card-inner'>
					<div className='login-info'>
						<div className='login-info-content'>
							<div className='login-accent-dot' />
							<span className='login-welcome'>Glömt lösenordet?</span>
							<h2>Ingen fara</h2>
							<p className='login-info-subtitle'>Skriv in din e-post så skickar vi återställningsinstruktioner</p>
							<div className='login-accent-line' />
						</div>
					</div>
					<div className='login-form-section'>
						<form onSubmit={handleSubmit(onSubmit)}>
              {success && <Help type='success' icon='fas fa-thumbs-up' header={false}>{success}</Help>}
              {error && <Help type='danger' icon='fas fa-exclamation' header={false}>{error.message}</Help>}
							<Input
								controls={{ register }}
								name='email'
								options={{ required: true }}
								label='E-post'
								type='text'
								placeholder='din@epost.se'
							/>
							<button type='submit' disabled={sending} className='btn login-btn'>
								{sending ? 'Skickar...' : 'Återställ lösenord'}
							</button>
						</form>
						<div className='login-card-links'>
							<p className='login-register-link'>
								<a href='#/login'>Tillbaka till inloggning</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
